<template>
        <div class="second-modal-block">
            <template v-if="open_modal">
                <div class="ant">
                    <template v-if="new_rate.rate == 1">
                        <img src="/images/rates/ants/bad_full.svg" alt="" />
                    </template>
                    <template v-if="new_rate.rate == 2">
                        <img src="/images/rates/ants/good_full.svg" alt="" />
                    </template>
                    <template v-if="new_rate.rate == 3">
                        <img src="/images/rates/ants/cool_full.svg" alt="" />
                    </template>
                </div>
                <div class="d-flex flex-column mb-10">
                    <span>Вы уверены, что хотите отправить отзыв?</span>
                    <span>В дальнейшем отзыв нельзя будет удалить или отредактировать</span>
                </div>
                <div class="buttons d-flex">
                    <a class="send-rate-form__btn2"  @click="edit()">Редактировать</a>
                    <a class="send-rate-form__btn"  @click="save()">Отправить</a>
                </div>
            </template>
            <template v-else>
                <div class="d-flex flex-column">
                    <span>Отзыв отправлен!</span>
                    <span>Благодарим за мнение</span>
                </div>
            </template>
        </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    data() {
        return {
            open_modal : true
        }
    },
    props: ['new_rate'],
    methods: {
        ...mapActions(['create_rate']),
        edit(){
            this.$emit('edit_comment', true)
        },

        save(){
            this.create_rate({ rate: this.new_rate })
                .then(() => {
                    this.open_modal = false
                })
                .catch((err) => {
                    console.log(err.message)
                })
        },
    },
}
</script>

<style scoped>

* {
    margin: 0 auto;
}

.ant {
    width: 296px;
    height: 190px;
    background: #ffffff;
    border-radius: 30px;
    display: flex;
    padding: 40px 35px;
    margin-bottom: 10px;
    justify-content: space-between;
}

.send-rate-form__btn {
    margin-top: 40px;
    border-radius: 62px;
    background: #ed7428;
    padding: 20px;
    font-size: 18px;
    line-height: 1;
    color: #f8f8f8 !important;
}

.send-rate-form__btn2 {
    margin-top: 40px;
    border-radius: 62px;
    background: #f8f8f8;
    padding: 20px;
    font-size: 18px;
    line-height: 1;
    color: #ed7428 !important;
    border: 1px solid #ed7428
}
</style>